import * as React from 'react';
// mui
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Box, useMediaQuery, useTheme } from '@mui/material';
// redux
import { useSelector } from 'react-redux';
import { selectAllProjects } from '../../../store/selectors/projectSelectors';
// types
import Project from '../../../interfaces/Project.interface';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface ProjectExclusionSelectProps {
  onChange: (projectIds: number[]) => void;
}

export default function ProjectExclusionSelect(props: ProjectExclusionSelectProps) {
  // props
  const onChangeCallback = props.onChange;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // redux
  const localProjects: Project[] = useSelector(selectAllProjects());

  // local state
  const [ projectName, setProjectName ] = React.useState<number[]>([]);

  const handleChange = (event: SelectChangeEvent<typeof projectName>) => {
    const value: number[] | string = event.target.value;
    const projects: number[] = typeof value === 'string' ? [] : value;
    setProjectName(projects);
    onChangeCallback(projects);
  };

  return (
    <Box my={1} mx={isMobile ? 1.5 : 10}>
      <FormControl fullWidth>
        <InputLabel>Excluded Projects</InputLabel>
        <Select
          multiple
          value={projectName}
          onChange={handleChange}
          input={<OutlinedInput label="Excluded Projects" />}
          MenuProps={MenuProps}
        >
          {localProjects.map((project: Project) => (
            <MenuItem key={project.id} value={project.id}>{project.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}